import store from '@/store'

/**
 * @see https://router.vuejs.org/en/advanced/navigation-guards.html
 *
 * Redirect to fan home page if already logged in.
 * Used to guard auth pages(ex. register, login) from logged-in users
 */
export const redirectIfLoggedIn = (to, from, next) => {
  if (store.getters['auth/isLoggedIn']) {
    next({ name: 'fan-home' })
    return
  }

  next()
}

/**
 * @see https://router.vuejs.org/en/advanced/navigation-guards.html
 *
 * Redirect to login page if not logged in.
 * Used to guard private pages from not-logged-in users
 */
export const redirectIfNotLoggedIn = (to, from, next) => {
  if (!store.getters['auth/isLoggedIn']) {
    next({ name: 'account-login' })
    return
  }

  next()
}

export const requireUserType = (to, from, next) => {
  const userType = store.getters['auth/isLoggedIn'] ? (store.getters['profile/isArtist'] ? 'artist' : 'fan') : 'anon'

  if (to.matched.some(record => record.meta.requireUserType && record.meta.requireUserType !== userType)) {
    next('/')
  } else {
    next()
  }
}

export const requireLogin = (to, from, next) => {
  if (store.getters['auth/isLoggedIn']) {
    next()
    return
  }

  if (to.matched.some(record => record.meta.requireLogin)) {
    next({ name: 'account-login', query: { next: to.fullPath } })
    return
  }

  next()
}



// WEBPACK FOOTER //
// ./src/router/guard.js